module.exports = __webpack_public_path__ + "static/media/cropped_Rupesh.f1d5567a.png";